<template>
  <div class="vue-images">
    <gallery :id="gallery_id" :class="gallery_class"  :images="images" :url="url" :readonly="readonly" @changeIndex="changeImg($event)" @removeImage="removeImg($event)"></gallery>
    <div v-if="images.length<1" class="row">
    <div class="col-sm-12" :class="gallery_class">No photos available.</div>
    </div>
    <dropzone v-if="!readonly" :url="url" :extra_params="extra_params" v-on:vdropzone-success="uploadSuccess" v-on:vdropzone-error="alertError" acceptedFileTypes="image/*">
    </dropzone>
    <div v-if="errors.length>0" class="alert alert-danger alert-dismissible" role="alert">
      <ul class="list-unstyled" v-if="errors.length>0">
        <li v-for="item in errors">
          {{item}}
        </li>
      </ul>
    </div>
    <div ref="lightbox" class="lightbox" v-show="isShow" @click="isShow=!modalclose">
      <fancybox :entryId="entry_id" ref="fancybox" :url="url" :images="images" :index="index" :reset="!isShow" @play="playImg" @pause="pauseImg" @close="closeImg" @addIndex="nextImg" @decIndex="prevImg" :showclosebutton="showclosebutton" :showcaption="showcaption" :imagecountseparator="imagecountseparator" :showimagecount="showimagecount">
      </fancybox>
      <paginator :images="images" :url="url" :activeIndex="index" @changeIndex="changeImg($event)" v-show="showthumbnails"></paginator>
    </div>
  </div>
</template>

<script>
  import gallery from './gallery.vue'
  import fancybox from './fancybox.vue'
  import paginator from './paginator.vue'
  import dropzone from './dropzone.vue'

  export function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
      let cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].trim();
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
      }
      }
  }
  return cookieValue;
}

  export default {
    name: 'lightbox',
    props: {
      url: {
          type: String,
          required: true
      },
      entry_id: {
          type: String,
          default: ''
      },
      gallery_id: {
          type: String,
          default: ''
      },
      gallery_class: {
          type: String,
          default: ''
      },
      readonly: {
          type: Boolean,
          default: false
      },
      extra_params: {
          type: String,
          default: ''
      },
      modalclose: {
          type: Boolean,
          default: true
      },
      keyinput: {
          type: Boolean,
          default: true
      },
      mousescroll: {
          type: Boolean,
          default: true
      },
      showclosebutton: {
          type: Boolean,
          default: true
      },
      showcaption: {
          type: Boolean,
          default: true,
      },
      imagecountseparator: {
          type: String,
          default: 'of'
      },
      showimagecount: {
          type: Boolean,
          default: true
      },
      showthumbnails: {
          type: Boolean,
          default: true
      }
    },
    computed: {
      images () {
        let retArr = [];
        let len = this.imgs.length;
        this.imgs.forEach((item, index) => {
          item['index'] = index + 1;
          item['total'] = len;
          item['isActive'] = false;
          retArr.push(item)
        });
        return retArr
      },
      errors () {
        let retArr = [];
        let len = this.errorList.length;
        this.errorList.forEach((item, index) => {
          item['index'] = index + 1;
          item['total'] = len;
          item['isActive'] = false;
          retArr.push(item)
        });
        return retArr
      }
    },
    data () {
      return {
        imgs: [{}],
        errorList: [],
        isShow: false,
        index: -1,
        playTimer: null,
        touchPoint: {
          prev: 0,
          now: 0
        }
      }
    },
    created () {
      if (this.isShow) {
        window.addEventListener('keydown', this.keyFun);
        window.addEventListener('mousewheel', this.wheelFun, { passive: true });
        this.$refs.lightbox.addEventListener('touchstart', this.touchFun, { passive: true })
      }
    },
    methods: {
      openImg () {
        this.isShow = true
      },
      playImg () {
        var that = this
        this.playTimer = window.setInterval(that.nextImg, 2000)
      },
      pauseImg () {
        window.clearInterval(this.playTimer)
      },
      closeImg () {
        this.isShow = false
      },
      nextImg () {
        if (this.index < this.images.length - 1) {
          this.index++
        } else {
          this.index = 0
        }
      },
      prevImg () {
        if (this.index > 0) {
          this.index--
        }
      },
      changeImg (event) {
        this.isShow = true
        this.index = event
      },
      removeImg (image_id) {
        if (this.imgs.length > 1) {
            this.index = 0
        } else {
            this.index = -1
        }
        this.$http.delete(this.url+image_id, {headers: {'X-CSRFToken': getCookie('csrftoken')}}).then(response => {
           this.imgs = this.imgs.filter(function (item) {
                return response.data.id != item.id;
            })
        });
      },
      keyFun (event) {
        event.preventDefault()
        if (this.keyinput) {
          var that = this
          switch (event.keyCode) {
            case 27:
              this.closeImg()
              break
            case 37:
              if (this.index > 0) {
                this.$refs.fancybox.$refs.images[this.index].classList.add('slideOutRight')
                window.setTimeout(() => {
                  that.$refs.fancybox._data.next = true
                  that.$refs.fancybox._data.animation = true
                  that.prevImg()
                }, 375)
              }
              break
            case 39:
              if (this.index < this.images[this.index].total - 1) {
                this.$refs.fancybox.$refs.images[this.index].classList.add('slideOutLeft')
                window.setTimeout(() => {
                  that.$refs.fancybox._data.next = false
                  that.$refs.fancybox._data.animation = true
                  that.nextImg()
                }, 375)
              }
              break
            default:
              return
          }
        } else {
          return
        }
      },
      wheelFun (event) {
        if (this.mousescroll) {
          event.stopPropagation()
          var that = this
          if (event.deltaY > 0) {
            if (this.index < this.images[this.index].total - 1) {
              this.$refs.fancybox.$refs.images[this.index].classList.add('slideOutLeft')
              window.setTimeout(() => {
                that.$refs.fancybox._data.next = false
                that.$refs.fancybox._data.animation = true
                that.nextImg()
              }, 375)
            }
          } else {
            if (this.index > 0) {
              this.$refs.fancybox.$refs.images[this.index].classList.add('slideOutRight')
              window.setTimeout(() => {
                that.$refs.fancybox._data.next = true
                that.$refs.fancybox._data.animation = true
                that.prevImg()
              }, 375)
            }
          }
        } else {
          return
        }
      },
      touchFun (event) {
        event.stopPropagation()
        this.touchPoint.prev = event.touches[0].clientX
      },
      endFun (event) {
        event.stopPropagation()
        this.touchPoint.now = event.changedTouches[0].clientX
        var that = this
        if (this.touchPoint.prev > this.touchPoint.now + 50) {
          if (this.index < this.images[this.index].total - 1) {
            this.$refs.fancybox.$refs.images[this.index].classList.add('slideOutLeft')
            window.setTimeout(() => {
              that.$refs.fancybox._data.next = false
              that.$refs.fancybox._data.animation = true
              that.nextImg()
            }, 375)
          }
        } else if (this.touchPoint.now > this.touchPoint.prev + 50) {
          if (this.index > 0) {
            this.$refs.fancybox.$refs.images[this.index].classList.add('slideOutRight')
            window.setTimeout(() => {
              that.$refs.fancybox._data.next = true
              that.$refs.fancybox._data.animation = true
              that.prevImg()
            }, 375)
          }
        }
      },
      uploadSuccess (file, response) {
        if (response.hasOwnProperty('image')) {
              this.imgs.push(response['image'])
        }
      },
      alertError (file, error, xhr) {
        this.errors.push(file.name + ': ' + error);
      },
    },
    watch: {
      isShow () {
        if (this.isShow) {
          window.addEventListener('keydown', this.keyFun)
          this.$refs.lightbox.addEventListener('mousewheel', this.wheelFun, { passive: true})
          this.$refs.lightbox.addEventListener('touchstart', this.touchFun, { passive: true})
          this.$refs.lightbox.addEventListener('touchend', this.endFun)
        } else {
          this.pauseImg()
          window.removeEventListener('keydown', this.keyFun)
          this.$refs.lightbox.removeEventListener('mousewheel', this.wheelFun, { passive: true})
          this.$refs.lightbox.removeEventListener('touchstart', this.touchFun, { passive: true})
          this.$refs.lightbox.removeEventListener('touchend', this.endFun)
        }
      }
    },
    components: {
      gallery,
      fancybox,
      paginator,
      dropzone
    },
    mounted() {
      this.$http.get(this.url+'?'+this.extra_params).then(response => {
         this.imgs = response.data;
      });
    }
}
</script>

<style>
.lightbox {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  width: 100%;
  height: 100%;
  padding: 2px;
  background: rgba(0, 0, 0, 0.8);
  box-sizing: border-box;
  font-size: 0;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}
</style>
